import { useFormContext, useController } from "react-hook-form";
import Label from "./Label";
import InputError from "./InputError";
import { useCurrentLanguage } from "@/i18n/useLocalized";
import { localizedCountries } from "@/i18n/countries";

import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

import style from "./InputPhone.module.css";

// see this https://github.com/goveo/react-international-phone

function InputPhone({ name, required, label, ...props }) {
	const language = useCurrentLanguage();
	const {
		register,
		formState: { errors, isSubmitting },
	} = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({ name });

	return (
		<div className={style.holder}>
			{label && (
				<Label required={required} htmlFor={name}>
					{label}
				</Label>
			)}

			<PhoneInput
				className={style.input}
				defaultCountry="ba"
				countries={localizedCountries(language)}
				id={name}
				value={field.value}
				onChange={field.onChange}
				required={required}
				disabled={isSubmitting}
			/>

			{errors[name] && <InputError error={errors[name]} />}
		</div>
	);
}

export default InputPhone;
